import { useContext } from 'react';

import { AppConfigContext } from 'src/config';

export const useAppConfig = () => {
  const context = useContext(AppConfigContext);

  /* istanbul ignore if -- @preserve */
  if (context === undefined) {
    throw new Error('useAppConfig must be used within an AppConfigProvider');
  }

  return context;
};
